<template>
  <div :id="id">
    <form role="search" method="get" v-on:submit.prevent>
      <div class="form-group">
        <label>{{ titel }}</label>
        <input
          v-model="term"
          v-debounce:600ms="termDebounce"
          type="search"
          placeholder="Zoeken"
          name="s"
        />

        <button
          @click="clickSearch()"
          type="submit"
          class="btn btn-primary"
          value="Zoek"
        >
          Zoek
        </button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
    },
    titel: {
      type: String,
      default: "Zoek",
    },
  },

  computed: {
    termSearch: {
      get() {
        return this.$store.state.termSearch;
      },
      set(value) {
        this.$store.commit("updateTermSearch", value);
      },
    },
    term: {
      get() {
        return this.$store.state.term;
      },
      set(value) {
        this.$store.commit("updateTerm", value);
      },
    },
    clickedSearchButton: {
      set(value) {
        this.$store.commit("incrementClickedSearchButton", value);
      },
      get() {
        return this.$store.state.clickedSearchButton;
      },
    },
  },

  methods: {
    termDebounce() {
      if (this.term && this.term.length >= 3) {
        this.termSearch = this.term;
      }
    },
    clickSearch() {
      if (this.term && this.term.length >= 3) {
        this.clickedSearchButton = this.clickedSearchButton + 1;
      }
    },
  },
};
</script>

<style lang="scss">
.swk-zoeken-form {
  display: flex;
  flex-flow: row wrap;
}

button {
  cursor: pointer;
}
</style>
